let isMapToggleBound = false;

function mapLocationToggle() {
    const isMobile = $(window).width() < 1024;

    if (isMobile && !isMapToggleBound) {
        $('.map_location .wp-block-heading').each(function (){
            const content = $(this).text();
            $(this).text('').append(`<button type="button" aria-expanded="false">${content}</button>`)
            $(this).siblings().attr('aria-hidden', 'true');
        });
        $('body').on('click.mobileMapToggle', '.map_location > .wp-block-heading button', function (e) {
            e.preventDefault();

            const $heading = $(this);
            $heading.toggleClass('open');

            $heading.parent().toggleClass('open');
            $heading.attr('aria-expanded', $(this).parent().hasClass('open') ? 'true' : 'false');
            $heading.parent().siblings().attr('aria-hidden', $(this).parent().hasClass('open') ? 'false' : 'true');

            const $nextSection = $heading.parent().nextUntil('h2.wp-block-heading');
            $nextSection.slideToggle(150, function () {
                if ($(this).is(':visible')) {
                    $(this).css('display', 'flex');
                }
            });
        });

        isMapToggleBound = true;
    } else if (!isMobile && isMapToggleBound) {
        $('.map_location .wp-block-heading').each(function (){
            const content = $(this).text();
            $(this).text('').append(`${content}`)
            $(this).siblings().removeAttr('aria-hidden');
        });
        $('body').off('click.mobileMapToggle');
        isMapToggleBound = false;
    }
}

$(document).ready(function () {
    mapLocationToggle();
    $(window).on('resize', mapLocationToggle);

    $('.map_location__locations-item').each(function (){
        let content = $(this).children('p:last-child').text();
        $(this).children('p:last-child').remove();
        $(this).append(`<dd>${content}</dd>`);
    });
});